import { render, staticRenderFns } from "./BannerUbicasa.vue?vue&type=template&id=533d6a98&scoped=true"
import script from "./BannerUbicasa.vue?vue&type=script&lang=js"
export * from "./BannerUbicasa.vue?vue&type=script&lang=js"
import style0 from "./BannerUbicasa.vue?vue&type=style&index=0&id=533d6a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533d6a98",
  null
  
)

export default component.exports